import { graphql } from '@api/generated';
import {
  UpsertCustomerContactsMutation,
  UpsertCustomerContactsMutationVariables,
} from '@api/generated/graphql';
import { useMutation } from '@apollo/client/react';
import { FetchResult } from '@apollo/client';
import { GraphQLError } from 'graphql';

export const UPSERT_CUSTOMER_CONTACTS_MUTATION = graphql(`
  mutation UpsertCustomerContacts(
    $input: [ContactUpsertInput!]!
    $tenantId: ID!
    $customerId: ID!
  ) {
    upsertCustomerContact(
      input: $input
      tenantId: $tenantId
      customerId: $customerId
    )
  }
`);

export const useUpsertCustomerContactsMutation = () => {
  const [mutate, { called, data, error, loading, reset }] = useMutation<
    UpsertCustomerContactsMutation,
    UpsertCustomerContactsMutationVariables
  >(UPSERT_CUSTOMER_CONTACTS_MUTATION);

  const upsertCustomerContactsMutation = async (
    variables: UpsertCustomerContactsMutationVariables,
  ) => {
    try {
      return await mutate({
        variables,
      });
    } catch (_e) {
      const errorResult: FetchResult<UpsertCustomerContactsMutation> = {
        data: null,
        errors: [new GraphQLError('Could not upsert customer contact')],
      };
      return errorResult;
    }
  };

  return {
    upsertCustomerContactsMutation,
    data,
    error,
    loading,
    reset,
    called,
  };
};
